import { render, staticRenderFns } from "./dealer-record.vue?vue&type=template&id=10fa1604&scoped=true&"
import script from "./dealer-record.vue?vue&type=script&lang=js&"
export * from "./dealer-record.vue?vue&type=script&lang=js&"
import style0 from "./dealer-record.vue?vue&type=style&index=0&id=10fa1604&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa1604",
  null
  
)

export default component.exports